import _draftJs from 'draft-js';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
function addText(editorState, bufferText) {
  var contentState = _draftJs.Modifier.insertText(
    editorState.getCurrentContent(),
    editorState.getSelection(),
    bufferText,
  );
  return _draftJs.EditorState.push(editorState, contentState, 'insert-characters');
}
function replaceText(editorState, bufferText) {
  var contentState = _draftJs.Modifier.replaceText(
    editorState.getCurrentContent(),
    editorState.getSelection(),
    bufferText,
  );
  return _draftJs.EditorState.push(editorState, contentState, 'insert-characters');
}
export { addText };
export { replaceText };
